import { Location } from 'history';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router';

import { CHANGE_INITIAL_PASSWORD_URL, ROOT_URL } from '@/constants/RouterConstants';
import { getLoggedInUserSelector } from '@/store/selectors/authenticationSelectors';

interface Props {
  children: React.ReactNode;
}

function InitialPasswordChecker({ children }: Props) {
  const user = useSelector(getLoggedInUserSelector);
  const history = useHistory();
  const [redirectTo, setRedirectTo] = useState<Location | null>(null);

  if (user.passwordChangeRequired && history.location.pathname !== CHANGE_INITIAL_PASSWORD_URL) {
    if (!redirectTo) setRedirectTo(history.location);
    return <Redirect to={CHANGE_INITIAL_PASSWORD_URL} />;
  }

  if (!user.passwordChangeRequired && history.location.pathname === CHANGE_INITIAL_PASSWORD_URL) {
    return <Redirect to={redirectTo ?? ROOT_URL} />;
  }

  return <>{children}</>;
}

export default InitialPasswordChecker;
